import { h, Component } from 'preact';
import Store from 'store/store';
import s from './kaltura.sss';

export default class Kaltura extends Component {

	componentDidMount() {
		if (typeof this.props.onPlayerReady === 'function') {
			this.props.onPlayerReady();
			Store.emit('ENSIGHTEN_VIDEO_PLAY', { videoTitle: this.props?.activeVideo?.name })
		}
	}

	addPlayerVars = (activeVideo, autoplay, muted) => {
		let src = activeVideo.disneySrc;
		if (autoplay) {
			src += (src.match(/\?/) ? '&' : '?') + 'flashvars[autoPlay]=true';
		}
		if (muted) {
			src += (src.match(/\?/) ? '&' : '?') + 'flashvars[autoPMute]=true';
		}
		return src;
	};

	render(props) {
		const { activeVideo, autoplay, muted } = props;
		const src = this.addPlayerVars(activeVideo, autoplay, muted);

		return (
			<iframe
				id="kaltura_player"
				class={s.iframe}
				src={src}
				allowfullscreen
				webkitallowfullscreen
				mozAllowFullScreen
				allow="autoplay *; fullscreen *; encrypted-media *"
				sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
				frameborder="0"
				title="Kaltura Player"
			/>
		);
	}
}
